import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import adhaan from "../../images/FlipjoblogoResize.png";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as constants from "../../utils/Constants";
import { CircularProgress } from "@mui/material";
import background from "../../images/login_bg/bg.png";
import searc from "../../images/login_bg/searc.gif";
import searcho from "../../images/login_bg/searcho.gif";

const Login = ({ history }) => {
  const [loginData, setLoginData] = useState({});
  const [isSpin, setIsSpin] = useState(false);

  var state = useLocation().state;
  if (localStorage.getItem("user")) {
    localStorage.setItem("user", null);
  }
  // const handleBlur = (e) => {
  //   const newLoginData = { ...loginData };
  //   newLoginData[e.target.name] = e.target.value;
  //   setLoginData(newLoginData);
  // };
  const [input, setInput] = useState({
    emailId: "",
    password: "",
  });
  const [error, setError] = useState({
    emailId: "",
    password: "",
  });
  const onInputChange = (e) => {
    const { name, value } = e.target;
    const newLoginData = { ...loginData };
    newLoginData[e.target.name] = e.target.value;
    setLoginData(newLoginData);
    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));
    validateInput(e);
  };
  const validateInput = (e) => {
    let { name, value } = e.target;
    setError((prev) => {
      const stateObj = { ...prev, [name]: "" };
      switch (name) {
        case "emailId":
          if (!value) {
            stateObj[name] = "Please Enter Email Id.";
          }
          if (value) {
            stateObj[name] =
              [/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/].every((pattern) =>
                pattern.test(value)
              ) || "Invalid Email";
          }
          break;
        case "password":
          if (!value) {
            stateObj[name] = "Please enter Password.";
          }
          break;
        default:
          break;
      }
      return stateObj;
    });
  };
  if (!state) {
    state = {
      emailId: "",
      password: "",
    };
  }
  async function loadAgentProfile(agentId) {
    try {
      const loggedInUser = JSON.parse(localStorage.getItem("user"));
      let response = await fetch(
        `${constants.GetRecruitingAgentByIdUrl}/${agentId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${loggedInUser.sessionToken}`,
          },
        }
      );
      let res = await response.json();
      if (res) {
        history.push({
          pathname: "/agent-profile",
          state: res.data,
        });
      }
    } catch (err) {
      console.error(err);
      // Handle errors here
    }
  }
  const submitHandler = (e) => {
    setIsSpin(true);
    e.preventDefault();
    var url = constants.LoginUrl;

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Schema: constants.Schema,
      },
      body: JSON.stringify(loginData),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          if (res.message.messageCode) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            // let creds = {};
            localStorage.setItem("user", JSON.stringify(res?.data));
            setTimeout(() => {
              if (
                (res.data.roles === "Recruitment Agent" &&
                  res.data.agentStatus === "Unverified") ||
                res.data.agentStatus === "Approved"
              ) {
                loadAgentProfile(res.data.userId);
              } else if (
                res.data.roles === "Recruitment Agent" &&
                res.data.agentStatus === "Accepted"
              ) {
                e.preventDefault();
                history.push({ pathname: "/agent-dashboard" });
              } else if (res.data.roles === "Admin") {
                e.preventDefault();
                history.push({ pathname: "/statistics" });
              } else if (res.data.roles === "Accountant") {
                e.preventDefault();
                history.push({ pathname: "/list-invoice" });
              } else if (res.data.roles === "Key Account Manager") {
                e.preventDefault();
                history.push({ pathname: "/statistics" });
              } else {
                e.preventDefault();
                history.push({ pathname: "/dashboard" });
              }
            }, 3000);
          }
        } else if (res.error) {
          if (res.error.errorCode) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setTimeout(() => {
              setIsSpin(false);
            }, 3000);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setIsSpin(false);
      });
  };
  const setCookie = () => {
    var u = document.getElementById("emailId").value;
    var p = document.getElementById("password").value;
    document.cookie = "myUsername=" + u + ";path=https://jobsrot.in";
    document.cookie = "myPassword=" + p + ";path=https://jobsrot.in";
  };
  const getcookiedata = () => {
    var user = getCookie("myUsername");
    var pwd = getCookie("myPassword");
    document.getElementById("emailId").value = user;
    state.emailId = user;
    const newLoginData = { ...loginData };
    newLoginData["emailId"] = user;
    newLoginData["password"] = pwd;
    setLoginData(newLoginData);
    setInput((prev) => ({
      ...prev,
      ["emailId"]: user,
      ["password"]: pwd,
    }));
    document.getElementById("password").value = pwd;
  };
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  return (
    <div className="authentication h-100 p-meddle">
      <div className="container" style={{ background: "#fff" }}>
        <div
          className="row justify-content-center h-100 align-items-center background-image-login"
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: "",
            height: "100vh",
            // backgroundImage: `url(${background})`, backgroundSize: "", height: "100vh"
          }}
        >
          <div
            className="col-md-3 show-desktop-animation show-results"
            // style={{height: "100vh",display: 'flex',flexDirection: 'column',justifyContent: 'center' }}
          >
            <img src={searcho} style={{ width: "250px" }} />
          </div>
          <div className="col-md-6">
            <div className="authentication-content">
              {/* authentication-content */}
              <div className="row no-gutters">
                <div className="col-xl-12">
                  <div className="auth-form" onLoad={getcookiedata}>
                    <div className="text-center mb-3">
                      <Link to="/">
                        <img className="" src={adhaan} alt="" />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4 text-#58595b">
                      Sign in your account
                    </h4>
                    <form action="" onSubmit={(e) => submitHandler(e)}>
                      <div className="form-group">
                        <label className="mb-1 text-#58595b">
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          id="emailId"
                          className={
                            error.emailId.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                          defaultValue={state.emailId}
                          placeholder="Email"
                          name="emailId"
                          value={input.emailId}
                          onChange={onInputChange}
                          onBlur={validateInput}
                        />
                        {error.emailId && (
                          <span
                            style={{
                              paddingLeft: 10,
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "0px",
                            }}
                            className="err"
                          >
                            {error.emailId}
                          </span>
                        )}
                      </div>
                      <div className="form-group ">
                        <label className="mb-1 text-#58595b">
                          <strong>Password</strong>
                        </label>
                        <input
                          type="password"
                          id="password"
                          defaultValue={state.password}
                          name="password"
                          maxLength="12"
                          minLength="4"
                          placeholder="Password"
                          // onChange={handleBlur}
                          className={
                            error.password.length > 0
                              ? "is-invalid form-control"
                              : "form-control Color-box"
                          }
                          value={input.password}
                          onChange={onInputChange}
                          onBlur={validateInput}
                        />
                        {error.password && (
                          <span
                            style={{
                              color: "red",
                              fontSize: "13px",
                              marginLeft: "10px",
                            }}
                            className="err"
                          >
                            {error.password}
                          </span>
                        )}
                      </div>
                      <div className="form-row d-flex justify-content-between mt-4 mb-2">
                        <div className="form-group">
                          <div className="custom-control custom-checkbox ml-1">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="basic_checkbox_1"
                              onClick={setCookie}
                            />
                            <label
                              className="custom-control-label text-#58595b"
                              htmlFor="basic_checkbox_1"
                            >
                              Remember my preference
                            </label>
                          </div>
                        </div>
                        <div className="form-group">
                          <Link
                            className="text-#58595b"
                            to="/page-forgot-password"
                          >
                            Forgot Password?
                          </Link>
                        </div>
                      </div>
                      <div className="text-center">
                        <ToastContainer />
                        {isSpin ? (
                          <button
                            type="button"
                            className="btn bg-white text-primary btn-block"
                          >
                            <CircularProgress
                              color="inherit"
                              size={24}
                              sx={{
                                color: "green",
                              }}
                            />
                          </button>
                        ) : (
                          <input
                            type="submit"
                            value="Sign Me In"
                            style={{
                              backgroundColor: "#00ADEE",
                              border: "none",
                              boxShadow: "none",
                            }}
                            className="btn btn-primary btn-block"
                          ></input>
                        )}
                      </div>
                    </form>
                    <div className="new-account mt-3">
                      <p className="" style={{ color: "#58595b" }}>
                        Don't have an account?{" "}
                        <Link
                          className=""
                          style={{ color: "#00ADEE" }}
                          to="/page-register"
                        >
                          Sign up for Agent
                        </Link>
                      </p>
                      <br />
                      <Link
                        className=""
                        style={{ color: "#00ADEE" }}
                        to="/page-privacy-policy"
                      >
                        Privacy Policy
                      </Link>
                      <footer>
                        <p
                          align="center"
                          style={{
                            fontSize: "12px",
                            color: "#aba4a4",
                            bottom: "0px",
                            marginTop: "20px",
                          }}
                        >
                          Copyright ©2022 jobsrot. All rights reserved.
                        </p>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 show-desktop-animation2 show-results ">
            {/* <img src={suitcase} style={{width: '90px',top: '-110px',position: 'relative'}} />
              <img className='search-image' src={searchImg} style={{width: '150px',top: '-150px',left:'-10px',position: 'absolute'}} /> */}

            <img
              src={searc}
              style={{ width: "250px", top: "-110px", position: "relative" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
